import { FinancialTableType } from '../types';
import { tosApi } from './tosApi';
import { getInvalidatesTags } from './utils';

const BASE_URL = '/maritime/financial-tables';

export const financialTableApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    confirmFinancialTable: build.mutation<FinancialTableType, number>({
      query: (id) => ({
        url: `${BASE_URL}/${id}/manual-confirmation`,
        method: 'PATCH',
      }),
      invalidatesTags: (_result, error) =>
        getInvalidatesTags(error, [{ type: 'Stopover', code: '2' }]),
    }),
    removeFinancialTableConfirmation: build.mutation<void, number>({
      query: (id) => ({
        url: `${BASE_URL}/${id}/manual-confirmation`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, error) =>
        getInvalidatesTags(error, [{ type: 'Stopover', code: '2' }]),
    }),
  }),
  overrideExisting: true,
});

export const {
  useConfirmFinancialTableMutation,
  useRemoveFinancialTableConfirmationMutation,
} = financialTableApi;
